import { Card, Grid, Modal, Typography, Box, Button, DialogTitle, Dialog, DialogContent, DialogActions } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import React from 'react';

// const style = {
//     position: 'absolute',
//     top: '50%',
//     left: '50%',
//     transform: 'translate(-50%, -50%)',
//     width: 400,
//     boxShadow: 24,
//     p: 4,
//     display: 'grid',
//     justifyContent: 'center',
// };

export default function DeleteModal({ open, onClose, handleDelete, selectedItem, loading = false }) {
    return (

        <Dialog
            open={open}  // Controlled by parent component's open state
            onClose={onClose}  // Parent's onClose function controls the dialog close
            fullWidth={true}
            maxWidth="sm"
          
        >
            <DialogTitle sx={{ textAlign: "center" ,}}>
                <Typography id="delete-modal-title" variant="h5" component="h2"   sx={{ marginBottom: "20px" }}>
                    <DeleteIcon color="error" fontSize='large' />  </Typography>
                <Typography id="delete-modal-title" variant="h5" component="h2" sx={{marginTop:-2}}>
                    Are you sure you want to delete <strong>{selectedItem}</strong>?
                </Typography>
            </DialogTitle>
            <DialogActions sx={{ padding: "20px",marginTop:-2}}>

<Button className="custombutton" onClick={onClose} color="secondary"  sx={{
            padding: "8px 16px",
            width: "120px", // Fixed width for uniform buttons
          }}>
    Cancel
</Button>
<Button className="custombutton" onClick={handleDelete} variant="contained" color="success" disabled={loading} sx={{
            padding: "8px 16px",
            width: "120px", // Fixed width for uniform buttons
          }}>
    {loading ? "Deleting..." : "Delete"}
</Button>
</DialogActions>
            {/* <DialogContent>

                {/* <Card variant="outlined" sx={{ mb: 2, p: 2 }}>
                <CardContent>
                    <Typography variant="h5" >Admin Response </Typography>
                    <Grid container mt={1} spacing={1} alignItems="center">
                        <Grid item xs={12} sm={1.5} sx={{ fontWeight: 500, mr: 1 }}>
                            Status:
                        </Grid>
                        <Grid item xs={12} sm={9}>
                            {status}
                        </Grid>

                        <Grid item xs={12} sm={1.5} sx={{ fontWeight: 500, whiteSpace: 'nowrap', mr: 1 }}>
                            Remarks:
                        </Grid>
                        <Grid item xs={12} sm={9}>
                            {remarks}
                        </Grid>
                    </Grid>
                </CardContent>
            </Card> */}
{/* 
            </DialogContent> */}

            {/* <DialogActions>

                <Button className="custombutton" onClick={onClose} color="secondary">
                    Cancel
                </Button>
                <Button className="custombutton" onClick={handleDelete} variant="contained" color="success" >
                    Delete
                </Button>
            </DialogActions>  */}
        </Dialog >











        // <Modal
        //     open={open}
        //     onClose={onClose}
        //     aria-labelledby="delete-modal-title"
        //     aria-describedby="delete-modal-description"
        // >
        //     <Card sx={style}>
        //         <Box>
        //             <Typography
        //                 id="delete-modal-title"
        //                 variant="h6"
        //                 component="h2"
        //                 sx={{ textAlign: 'center', marginBottom: 2 }}
        //             >
        //                 <DeleteIcon color="error" fontSize='large' />
        //             </Typography>
        //             <Typography id="delete-modal-title" sx={{ textAlign: "center" }} variant="h5" component="h2">
        //                 Are you sure you want to delete <strong>{selectedItem}</strong>?
        //             </Typography>
        //             <Grid container mt={3} justifyContent="center" gap={2}>
        //                 <Button className="custombutton"
        //                     variant="outlined"
        //                     sx={{ width: "90px", color: 'grey' }}
        //                     onClick={onClose}
        //                 >
        //                     Cancel
        //                 </Button>
        //                 <Button className="custombutton"
        //                     variant="contained"
        //                     sx={{ width: "90px", backgroundColor: 'orange', color: 'white' }}
        //                     onClick={handleDelete}
        //                 >
        //                     Delete
        //                 </Button>
        //             </Grid>
        //         </Box>
        //     </Card>
        // </Modal>
    );
}


// import {
//     Dialog,
//     DialogTitle,
//     DialogActions,
//     Typography,
//     Button,
//   } from "@mui/material";
//   import DeleteIcon from "@mui/icons-material/Delete";
//   import React from "react";
  
//   export default function DeleteModal({ open, onClose, handleDelete, selectedItem }) {
//     return (
//       <Dialog
//         open={open} // Controlled by parent component's open state
//         onClose={onClose} // Parent's onClose function controls the dialog close
//         fullWidth={true}
//         maxWidth="sm"
//       >
//         <DialogTitle sx={{ textAlign: "center", paddingBottom: 2 }}>
//           <Typography
//             id="delete-modal-title"
//             variant="h5"
//             component="h2"
//             sx={{ marginBottom: "20px" }}
//           >
//             <DeleteIcon color="error" fontSize="large" />
//           </Typography>
//           <Typography id="delete-modal-title" variant="h5" component="h2">
//             Are you sure you want to delete <strong>{selectedItem}</strong>?
//           </Typography>
//         </DialogTitle>
  
//         <DialogActions
//           sx={{
//             display: "flex",
//             justifyContent: "center",
//             gap: "20px",
//             padding: "20px 24px",
//           }}
//         >
//           <Button
//             className="custombutton"
//             onClick={onClose}
//             color="secondary"
//             sx={{ padding: "8px 16px" }}
//           >
//             Cancel
//           </Button>
//           <Button
//             className="custombutton"
//             onClick={handleDelete}
//             variant="contained"
//             color="success"
//             sx={{ padding: "8px 16px" }}
//           >
//             Delete
//           </Button>
//         </DialogActions>
//       </Dialog>
//     );
//   }
  